<dialog-header [dialogRef]="dialogRef" headerKey="SELECT_PROJECT"></dialog-header>
<div class="dialog-content" mat-dialog-content>
  <mat-form-field >
    <mat-label>{{ 'PROJECT' | translate }}</mat-label>
    <input #input
           type="text"
           matInput
           [formControl]="projectControl"
           [matAutocomplete]="auto"
           (input)="filter()"
           (focus)="filter()">
    <mat-autocomplete
      requireSelection
      #auto="matAutocomplete"
      class="autocomplete-box"
      [displayWith]="getOptionText"
      (optionSelected)="change($event)"
    >
      <mat-option *ngFor="let option of filteredOptions" [value]="option">
        {{option.name}}  <ng-container *ngIf="option.actionsCount"> ({{ option.actionsCount }})</ng-container>
      </mat-option>
      <mat-option *ngIf="!filteredOptions.length" [disabled]="true">
        {{ 'NO_RESULT' | translate }}
      </mat-option>
    </mat-autocomplete>
    <button *ngIf="input.value" matSuffix mat-icon-button (click)="clear()">
      <mat-icon>close</mat-icon>
    </button>
  </mat-form-field>
</div>
